import { Dispatch } from "redux";

import { ItemsStateAction } from "@reducers/types/inventory/stock/items-state";

import { GET_INVENTORY_STOCK_ITEMS } from "./types";
import { fetchItems } from "@api/inventory/stock/items";

export const itemsFetchActionHandler =
  (query: any) => async (dispatch: Dispatch<ItemsStateAction>) => {
    dispatch({ type: GET_INVENTORY_STOCK_ITEMS.LOADING, payload: true });

    try {
      const res = await fetchItems(query);

      const { data, page, size, total } = res.data || {};

      dispatch({
        type: GET_INVENTORY_STOCK_ITEMS.SUCCESS,
        payload: {
          data: data,
          pagination: {
            page: page || 0,
            size: size || 0,
            total: total || 0,
          },
        },
      });
    } catch (err) {
      dispatch({ type: GET_INVENTORY_STOCK_ITEMS.ERROR, payload: err });
    }
  };
